/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import fetchWrapper from "../../helpers/fetchWrapper";
import {
  swalConfirm,
  swalError,
  swalSuccess,
} from "../../helpers/helperService";
import { Button, Spin } from "antd";
import { useEffect, useRef, useState } from "react";
import styles from "./FileUpload.module.scss";
import { FaEye } from "react-icons/fa6";
import { Modal } from "react-bootstrap";
import { ImCross } from "react-icons/im";

const getExtension = (type) => {
  if (type.startsWith("text")) {
    return "txt";
  }
  const typeName = type.split("/")[1];
  if (typeName == "vnd.ms-excel") {
    return "xls";
  }
  if (typeName == "vnd.openxmlformats-officedocument.spreadsheetml.sheet") {
    return "xlsx";
  }
  if (
    typeName == "vnd.openxmlformats-officedocument.wordprocessingml.document"
  ) {
    return "docx";
  }
  return typeName;
};

const allowedFileTypes = (types) => {
  const fileTypes = types.split(",").map((type) => getExtension(type));
  return fileTypes.join(", ");
};

export const FileUpload = React.forwardRef((props, ref) => {
  const {
    reference,
    reference_id,
    reloadAttachments,
    getFileLength,
    modalOnClick,
  } = props;
  const [fileState, setFileState] = useState([]);
  const [names, setNames] = useState([]);
  const [attachConfigs, setAttachConfigs] = useState({});
  const [files, setFileData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const { mode, deleteBtn } = props;
  const buttonRefInput = useRef();

  const onFileChange = (event) => {
    const namesArr = [...names];
    const fileArr = [...fileState];

    if (event.target.files && event.target.files.length > 0) {
      for (let i = 0; i < event.target.files.length; i++) {
        if (
          attachConfigs.allowed_type.includes(event.target.files[i].type) &&
          event.target.files[i].size <= attachConfigs.allowed_size
        ) {
          const fname = event.target.files[i].name;
          const name = fname
            .split(".")
            .slice(0, -1)
            .join(".");
          namesArr.push(name);
          fileArr.push(event.target.files[i]);
        } else {
          swalError(
            "Upload file ( " + event.target.files[i].name + " ) is not allowed"
          );
        }
      }
      setFileState(fileArr);
      setNames(namesArr);
      buttonRefInput.current.value = "";
    }
  };

  const changeName = (e) => {
    const index = e.target.name.replace("file_name_", "");
    const namesArr = [...names];
    namesArr[index] = e.target.value;
    setNames(namesArr);
  };

  // remove item which upload
  const removeCurrent = (index) => {
    const fileArr = [...fileState];
    const namesArr = [...names];
    if (index !== -1) {
      fileArr.splice(index, 1);
      namesArr.splice(index, 1);
      setFileState(fileArr);
      setNames(namesArr);
    }
  };

  const handleRemove = (index) => {
    swalConfirm("to remove this")
      .then((result) => {
        if (result.isConfirmed) {
          removeCurrent(index);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const createTable = () => {
    const table = [];
    if (fileState && fileState.length > 0) {
      for (let i = 0; i < fileState.length; i++) {
        table.push(
          <tr key={i}>
            <td className="text-center">
              {reference_id ? files?.length + i + 1 : i + 1}
            </td>
            <td>
              <input
                name={"file_name_" + i}
                key={i}
                onChange={changeName}
                value={names[i]}
                className={styles["file-input"]}
                autoComplete="off"
              />
            </td>
            {props.preview && (
              <td>
                {filePreview(fileState[i], getExtension(fileState[i]?.type))}
              </td>
            )}
            <td>{fileState[i].name}</td>
            <td>{fileState[i].type}</td>
            <td className="text-center">
              <button
                className={styles["remove-btn"]}
                onClick={() => handleRemove(i)}
                value={i}
                type="button"
              >
                <i className="fa fa-trash"></i>
              </button>
            </td>
          </tr>
        );
      }
    }
    return table;
  };

  // remove form Old List
  const removeFromList = async (ref, log_id) => {
    const rsp = await swalConfirm("to remove this")
      .then((result, agree) => {
        if (result.isConfirmed) {
          const delItem = fetchWrapper.patch("/attachment/delete-files", {
            attach_config_slug: ref,
            attach_log_id: [log_id],
          });
          return delItem;
        } else {
          return false;
        }
      })
      .catch((error) => {
        console.log(error);
      });

    if (rsp.data && rsp.message == "successfull") {
      setFileData(
        files.filter((entity) => {
          return entity.attach_log_id != log_id;
        })
      );
      swalSuccess("Attachment Deleted Successfully!");
    }
  };

  const formReset = () => {
    setFileState([]);
    setNames([]);
    setFileData([]);
    if (reference && reference_id) {
      fetchData(reference, reference_id);
    }
    Array.from(document.querySelectorAll("#files")).forEach(
      (input) => (input.value = "")
    );
  };

  // call from parent
  React.useImperativeHandle(ref, () => ({
    formReset,
    getUploadedFiles,
  }));

  const getUploadedFiles = () => {
    return files;
  };

  const fetchData = async (reference, reference_id) => {
    setLoading(true);
    const response = await fetchWrapper.post("attachment/uploaded-files", {
      attach_config_slug: reference,
      reference_id,
    });
    if (props.setPrevFiles) props.setPrevFiles(response.data);
    setFileData(response.data);
    setLoading(false);
  };

  const uploadNow = async (e) => {
    e.preventDefault();
    try {
      setBtnLoading(true);
      const params = new FormData();
      params.append("attach_config_slug", attachConfigs.attach_config_slug);

      if (reference_id) {
        params.append("reference_id", reference_id);
      } else {
        params.append("reference_id", attachConfigs.attach_config_id);
      }

      if (fileState.length > 0) {
        // fileState.map((file, index) => {
        // 	params.append('file_name[]', names[index]);
        // 	params.append('file', file);
        // });
        for (let index in fileState) {
          let file = fileState[index];
          params.append("file_name[]", names[index]);
          params.append("file", file);
        }
      }

      await fetchWrapper
        .post("attachment/upload", params, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then(function(response) {
          if (response.message == "success") {
            formReset();
            setBtnLoading(false);
            modalOnClick(false);
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    } catch (error) {
      setBtnLoading(false);
      swalError(error);
    }
  };

  const getAttachConfigs = async () => {
    await fetchWrapper
      .post("attachment/config", {
        attach_config_slug: reference,
      })
      .then((response) => {
        if (!response.error) {
          setAttachConfigs(response.data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    if (props.onChange) props.onChange(names, fileState);
  }, [names, fileState]);

  // load attachment form api
  useEffect(async () => {
    await getAttachConfigs();
    if (reference && reference_id) {
      await fetchData(reference, reference_id);
    }
    setLoading(false);
  }, [reference, reference_id, reloadAttachments]);

  useEffect(() => {
    getFileLength &&
      getFileLength((files.length ?? 0) + (fileState.length ?? 0));
  }, [files, fileState]);

  const filePreview = (file, type) => {
    let noPreview = ["docx", "xlsx", "xls", "txt"];
    if (noPreview.includes(type)) {
      return (
        <div>
          <p>No Preview</p>
        </div>
      );
    }
    if (file instanceof File) {
      return (
        <div>
          <object
            data={URL.createObjectURL(file)}
            height={100}
            width={100}
            style={{ overflow: "hidden" }}
          />
        </div>
      );
    }
    return (
      <div style={{ position: "relative", width: 100, height: 100 }}>
        <object
          data={file?.attach_path + `&rsct=${file?.attach_mime_type}`}
          height={100}
          width={100}
          style={{ overflow: "hidden" }}
        ></object>
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            borderRadius: "50%",
            padding: "8px",
            cursor: "pointer",
          }}
          onClick={() => {
            setPreviewModal(true);
          }}
        >
          <FaEye color="#fff" size={20} />
        </div>
        {previewModal && (
          <Modal
            show={previewModal}
            onHide={() => {
              setPreviewModal(false);
            }}
            size="lg"
            centered
          >
            <Modal.Header>
              <h3 className="card-title m-0 p-0 align-items-start flex-column">
                <div className="card-label font-weight-bolder text-dark d-block">
                  File Preview
                </div>
              </h3>

              <div className="d-flex align-items-center">
                <ImCross
                  className="text-danger cursor"
                  onClick={() => {
                    setPreviewModal(false);
                  }}
                />
              </div>
            </Modal.Header>
            <Modal.Body>
              <object
                data={file?.attach_path + `&rsct=${file?.attach_mime_type}`}
                height={700}
                width={"100%"}
                style={{ overflow: "hidden" }}
              ></object>
            </Modal.Body>
          </Modal>
        )}
      </div>
    );
  };

  return attachConfigs.attach_config_slug ? (
    <Spin spinning={loading || btnLoading}>
      <div
        className={styles["file-upload-area"]}
        style={{ borderTop: "1px solid #dfdfdf" }}
      >
        <input
          ref={buttonRefInput}
          type="file"
          id="files"
          name="files"
          onChange={onFileChange}
          multiple
          hidden
        />
        {(!mode || mode !== "view") && (
          <div className={styles["file-upload-header-area"]}>
            <h4>
              <i className="fa fa-file mr-1 file-icon"></i>
              {attachConfigs.attach_upload_label ?? "Upload File"}
              <div>
                Max Size: {Math.ceil(attachConfigs.allowed_size / 1048576)} MB |
                Allowed Files:
                {allowedFileTypes(attachConfigs.allowed_type)}
              </div>
            </h4>
            <Button
              type="primary"
              size="small"
              onClick={() => {
                return buttonRefInput?.current?.click();
              }}
            >
              <i className="fa fa-paperclip mr-1"></i>Select your files
            </Button>
          </div>
        )}

        <table className={styles["upload-table"]}>
          <thead>
            <tr>
              <th style={{ width: "40px", textAlign: "center" }}>SL</th>
              {mode !== "view" && <th>New Name</th>}
              {props.preview && <th>Preview</th>}
              <th>Name</th>
              <th>Type</th>
              <th style={{ width: "100px", textAlign: "center" }}>Action</th>
            </tr>
          </thead>
          {reference_id && (
            <tbody>
              {files?.length > 0 &&
                files?.map((file, index) => (
                  <tr key={file.attach_log_id.toString()}>
                    <td className="text-center">{index + 1}</td>
                    {mode !== "view" && <td></td>}
                    {props.preview && (
                      <td>
                        {filePreview(
                          file,
                          getExtension(file?.attach_mime_type)
                        )}
                      </td>
                    )}
                    <td>
                      <a
                        className={styles["file-link"]}
                        href={
                          file?.attach_path +
                          `&rsct=${
                            file?.attach_mime_type
                          }&rscd=attachment; filename="${`${
                            file?.attach_name
                          }.${getExtension(file?.attach_mime_type)}`}"`
                        }
                        target="_blank"
                        rel="noreferrer"
                        download={`${file?.attach_name}.${getExtension(
                          file?.attach_mime_type
                        )}`}
                      >
                        {file?.attach_name}
                      </a>
                    </td>
                    <td>{getExtension(file?.attach_mime_type)}</td>
                    <td className={styles["action-buttons"]}>
                      <a
                        // href={file?.attach_path}

                        href={
                          file?.attach_path +
                          `&rsct=${
                            file?.attach_mime_type
                          }&rscd=attachment; filename="${`${
                            file?.attach_name
                          }.${getExtension(file?.attach_mime_type)}`}"`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                        download={`${file?.attach_name}.${getExtension(
                          file?.attach_mime_type
                        )}`}
                      >
                        <button
                          className={styles["download-btn"]}
                          type="button"
                        >
                          <i className="fa fa-download"></i>
                        </button>
                      </a>
                      {(!mode || mode != "view") &&
                        (!deleteBtn || deleteBtn != "hide") && (
                          <button
                            className={styles["remove-btn"]}
                            value={file.attach_log_id}
                            onClick={() =>
                              removeFromList(
                                file?.attach_config_slug,
                                file?.attach_log_id
                              )
                            }
                            type="button"
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                        )}
                    </td>
                  </tr>
                ))}
            </tbody>
          )}
          {(!mode || mode !== "view") && <tbody>{createTable()}</tbody>}
          {(!mode || mode !== "view"
            ? files.length + fileState.length <= 0
            : files.length <= 0) && (
            <tbody>
              <tr>
                <td
                  colSpan={!mode || mode !== "view" ? 5 : 4}
                  className="text-center"
                >
                  No Attachments Found !
                </td>
              </tr>
            </tbody>
          )}
        </table>

        {(attachConfigs.upload_btn || props?.uploadBtn) &&
          fileState &&
          fileState.length > 0 && (
            <Button className="mt-2" type="primary" onClick={uploadNow}>
              <i className="fa fa-upload mr-1"></i>Upload
            </Button>
          )}
      </div>
    </Spin>
  ) : null;
});
